import { FdrImage } from '@hotelplan/supergraph-api';

export interface IWishlistItem {
  id: string;
  name: string;
  active: boolean;
  productsAmount?: number;
  image?: Omit<FdrImage, 'id'>;
}

export interface IWishlistItemProps extends IWishlistItem {
  editable?: boolean;
  className?: string;

  onClick?(wishlistId: string): void;

  onEdit?(e: React.MouseEvent<HTMLElement>): void;

  onRemove?(e: React.MouseEvent<HTMLElement>): void;
}

type TTypedObject = {
  __typename?: string;
};

export type TFdrWishlistProductHotel<T extends TTypedObject> = Extract<
  T,
  { __typename: 'FdrHotel' }
>;

export type TFdrWishlistProductCruise<T extends TTypedObject> = Extract<
  T,
  { __typename: 'FdrCruise' }
>;

export type TFdrWishlistProductRoundTrip<T extends TTypedObject> = Extract<
  T,
  { __typename: 'FdrRoundTrip' }
>;

export type TFdrWishlistProduct<T extends TTypedObject> =
  | TFdrWishlistProductHotel<T>
  | TFdrWishlistProductCruise<T>
  | TFdrWishlistProductRoundTrip<T>;

export const isFdrWishlistProductHotel = <T extends TTypedObject>(
  object: T
): object is TFdrWishlistProductHotel<T> => {
  return object?.__typename === 'FdrHotel';
};

export const isFdrWishlistProductCruise = <T extends TTypedObject>(
  object: T
): object is TFdrWishlistProductCruise<T> => {
  return object?.__typename === 'FdrCruise';
};

export const isFdrWishlistProductRoundTrip = <T extends TTypedObject>(
  object: T
): object is TFdrWishlistProductRoundTrip<T> => {
  return object?.__typename === 'FdrRoundTrip';
};

export const isFdrWishlistProduct = <T extends TTypedObject>(
  object: T
): object is TFdrWishlistProduct<T> => {
  return (
    isFdrWishlistProductHotel(object) ||
    isFdrWishlistProductCruise(object) ||
    isFdrWishlistProductRoundTrip(object)
  );
};
